import { DateTimeType } from './dateTypes';
import { z } from 'zod';

export const ExpensesRates = z.object({
    countryCode: z.string(),
    validFrom: DateTimeType,
    validTo: DateTimeType,
    rates: z.object({
        '24h': z.number(),
        '8h': z.number(),
        overnight: z.number(),
    }),
    city: z.string().nullish(),
});
export type ExpensesRates = z.infer<typeof ExpensesRates>;
